






























/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Module Helper
---------------------------------------- */

import { StoreModule } from "@store/service/Modules";
const module = new StoreModule('teams');

/* ----------------------------------------
     Cards
 ---------------------------------------- */

import Member from '@part/cards/Member.vue';

/** ----------------------------------------
    JS Modules
 ---------------------------------------- */

import { Team } from '@js/module/Team';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    props: {
        content: Object,
        members: Array
    },

    components: {
        Member
    },

    computed: {
        teams() {
            return this.members ? module.getters('getPersonsByName', this.members) : module.getters('getTeams');
        }
    },

    methods: {
        subtitle(value) {
            return value || this.content.subtitle[this.lang];
        },

        title(value) {
            return value || this.content.title[this.lang];
        },

        type: function(name, type) {
            return type && 'team__' + name + '--' + type || '';
        },

        cardType: function(type) {
            return type && 'team__grid--' + type;
        }
    },

    mounted() {
        this.$refs.grid.forEach(team => new Team(team));
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class TeamMembers extends Vue {}

